import { render } from "./BuyVip.vue?vue&type=template&id=7bceedc8&scoped=true"
import script from "./BuyVip.vue?vue&type=script&lang=js"
export * from "./BuyVip.vue?vue&type=script&lang=js"

import "./BuyVip.vue?vue&type=style&index=0&id=7bceedc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bceedc8"]])

export default __exports__